import axiosInstance from '../services/AxiosInstance';

export const getMerchantBalance = (getData) => {
  return axiosInstance.get("merchant-balance/list", {
    params: getData,
  });
};


export const getMerchantWalletBalance = () => {
  return axiosInstance.get(`merchant-balance/show`);
};

export const addMerchantBalance = (data) => {
  return axiosInstance.post("merchant-balance/create", data);
};

export const getMerchantBalanceCount = (data) => {
  return axiosInstance.get("merchant-balance/overview", data);
};

export const updateMerchantBalance = (id, data) => {
  return axiosInstance.put(`merchant-balance/update/${id}`, data);
};

export const fetchMerchantBalanceById = async () => {
    const response = await axiosInstance.get(`merchant-balance/show`);
    return response.data;
};
